<template>
  <div class="staging" v-if="!isProduction" :class="{ 'staging--small': isSmall }">
    You're in a testing environment.

    <i class="material-icons" @click="toggle" v-if="isSmall">chevron_right</i>
    <i class="material-icons" @click="toggle" v-else data-test="bar-close">close</i>
  </div>
</template>

<script>
import { setCookie, getCookie } from 'tiny-cookie'

export default {
  name: 'StagingBar',
  data() {
    return {
      isSmall: JSON.parse(getCookie('stagingBarSmall'))
    }
  },
  methods: {
    toggle() {
      this.isSmall = !this.isSmall
      setCookie('stagingBarSmall', this.isSmall, {
        expires: '10m'
      })
    }
  },
  computed: {
    isProduction() {
      return (
        window.location.href.includes('go.sennder.com') &&
        !window.location.href.includes('staging.go.sennder.com')
      )
    }
  }
}
</script>
